import gql from 'graphql-tag';

export const QUERY_LISTADO_PAGOS = gql(`
query BusquedaPagosCuentaNoAplicado($filter: [String], $sort: [String], $page: Int!, $size: Int!){
    listaPagosCuentaNoAplicado (criteria: { filter: $filter, sort: $sort, page: $page, size: $size }){
        totalElements
        firstElement
        results {
            id
            referenciaCliente
            importe
            divisa
            fechaPago
            tokenOperacion
            operacion{
                uuid
                acreedor {
                    id
                    idLegal
                    nombre
                    razonSocial
                    apellidos                   
                 }
                 deudor {
                    id
                    idLegal
                    nombre
                    razonSocial
                    apellidos 
                 }
            }
            usuario {
               nombre
               apellidos
               razonSocial
               tipo
            }
         }
    }
}
`);

export const ALTA_APLICADOS = gql(`
    mutation altaAplicados ($altaAplicadosRequest: AltaAplicadosRequestInput) {
        altaAplicados(altaAplicadosRequest: $altaAplicadosRequest) {
            reclamacionId
            pagoCuentaId
            importe
        }
    }
`);

export const BORRAR_APLICADOS = gql(`
    mutation borrarAplicado ($altaAplicadoRequest: AltaAplicadoRequestInput) {
        borrarAplicado(altaAplicadoRequest: $altaAplicadoRequest) {
            reclamacionId
            pagoCuentaId
            importe
        }
    }
`);